var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',[_vm._v("ic-20 ic-"+_vm._s(_setup.props.active ? 'markedevents' : 'x')+" ic-col-"+_vm._s(_setup.props.active ? 'ok' : 'primary'))])
}
var staticRenderFns = []

export { render, staticRenderFns }